import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { GreentripperPinIconComponent } from '../../../shared/components/greentripper-pin-icon/greentripper-pin-icon.component';

@Component({
  selector: 'app-stats-card',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, GreentripperPinIconComponent],
  template: `
    <div
      class="group flex flex-col items-center justify-center rounded-lg border border-greyscale-200 bg-white px-4 py-6 text-center"
    >
      <div
        class="mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 transition-transform duration-300 group-hover:scale-110"
      >
        @if (useGreentripperLogo) {
          <app-greentripper-pin-icon styleClass="w-5 h-5 text-primary-600 ml-[2px]" />
        } @else {
          <lucide-icon [name]="icon" class="text-primary-600" [size]="18"></lucide-icon>
        }
      </div>
      <span class="text-xl font-bold text-primary-600">{{ value }}</span>
      <span class="mt-0.5 text-xs text-greyscale-500">{{ label }}</span>
    </div>
  `,
})
export class StatsCardComponent {
  @Input() value: string = '';
  @Input() label: string = '';
  @Input() icon: string = 'activity';
  @Input() useGreentripperLogo: boolean = false;
}
